'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);

var _changeLocale = require('../../helpers/changeLocale');var _changeLocale2 = _interopRequireDefault(_changeLocale);
var _constants = require('../../constants');

var _LanguageSwitch = require('./LanguageSwitch.scss');var _LanguageSwitch2 = _interopRequireDefault(_LanguageSwitch);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Helpers
// Styles
var LanguageSwitch = function (_Component) {_inherits(LanguageSwitch, _Component);function LanguageSwitch() {var _temp, _this, _ret;_classCallCheck(this, LanguageSwitch);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.






    handleChange = function (evt, locale) {
      evt.preventDefault();var
      routeData = _this.props.routeData;

      if (routeData && routeData.locale === locale) {
        return;
      }

      (0, _changeLocale2.default)(locale, _this.props.routeData);
    }, _this.

    renderLanguageItems = function (languagesArray) {return languagesArray.map(function (item) {
        var style = _this.props.locale === 'ru' && _constants.languageFontOverride[item.value] ? {
          fontFamily: _constants.languageFontOverride[item.value] } :
        null;
        var handleSelect = function handleSelect(evt) {return _this.handleChange(evt, item.value);};
        return (
          _react2.default.createElement('span', { key: item.value },
            _react2.default.createElement('a', {
                href: (0, _changeLocale.getLocationWithLocale)(item.value, _this.props.routeData) || '/',
                onClick: handleSelect,
                style: style },

              item.flagIcon)));



      });}, _temp), _possibleConstructorReturn(_this, _ret);}LanguageSwitch.prototype.shouldComponentUpdate = function shouldComponentUpdate(_ref) {var locale = _ref.locale,routeData = _ref.routeData;var isLocaleChanged = locale !== this.props.locale;var isLocationChanged = (0, _get2.default)(routeData, 'location') !== (0, _get2.default)(this.props, 'routeData.location');return isLocaleChanged || isLocationChanged;};LanguageSwitch.prototype.

  render = function render() {var _this2 = this,_cx;
    var locales = _constants.languages.filter(function (_ref2) {var value = _ref2.value;return value !== _this2.props.locale;});
    return (
      _react2.default.createElement('div', {
          className: (0, _classnames2.default)(
          _LanguageSwitch2.default.languageSwitch, (_cx = {}, _cx[
          _LanguageSwitch2.default.largeIcons] = this.props.isLargeIcons, _cx),
          this.props.isRtl ? _LanguageSwitch2.default.left : _LanguageSwitch2.default.right) },


        this.renderLanguageItems(locales)));


  };return LanguageSwitch;}(_react.Component);


LanguageSwitch.propTypes = {
  locale: _propTypes2.default.string.isRequired,
  isRtl: _propTypes2.default.bool,
  routeData: _propTypes2.default.object,
  isLargeIcons: _propTypes2.default.bool };exports.default =


LanguageSwitch;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/LanguageSwitch/LanguageSwitch.js
// module id = 1211
// module chunks = 0